<div class="control" (click)="addControls()"  [ngClass]="{ 'hide-entry': !entry.base?.display }">
  <span class="material-symbols-outlined"> control_point </span>
  <span class="content-span">{{entry?.formControlAttributes?.label}}</span>
</div>
